module.exports = __webpack_public_path__ + "static/media/test16_2.da2c76f0.png";